import styled from "styled-components";
import {LobbyGridDefaultBox} from "./lobby-grid.default.box";

export const LobbyGridCasino777Box = styled(LobbyGridDefaultBox)`
  max-width: 100%;
  float: none;
`;